"use client";

import { useSyncExternalStore } from "react";

const KEY = "blaundry.privacy.v1";
const EVENT = "blaundry:privacy";
export type PrivacyChoice = "accepted" | "essential";
let memoryChoice: PrivacyChoice | null = null;

export function privacyChoice(): PrivacyChoice | null {
  if (typeof window === "undefined") return null;
  if ((navigator as Navigator & { globalPrivacyControl?: boolean }).globalPrivacyControl) return "essential";
  try {
    const value = localStorage.getItem(KEY);
    return value === "accepted" || value === "essential" ? value : memoryChoice;
  } catch { return memoryChoice; }
}
export function setPrivacyChoice(choice: PrivacyChoice) {
  memoryChoice = choice;
  try {
    localStorage.setItem(KEY, choice);
    if (choice === "essential") {
      sessionStorage.removeItem("blaundry.utm.sent");
      sessionStorage.removeItem("blaundry.sid");
    }
  } catch { /* The choice still applies to this page when storage is blocked. */ }
  window.dispatchEvent(new Event(EVENT));
}
function subscribe(callback: () => void) {
  window.addEventListener(EVENT, callback);
  window.addEventListener("storage", callback);
  return () => { window.removeEventListener(EVENT, callback); window.removeEventListener("storage", callback); };
}
export function usePrivacyChoice() {
  return useSyncExternalStore(subscribe, privacyChoice, () => null);
}
